import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
@Injectable()
export class AnalyticsService {

  constructor(private http: Http, private router: Router) { }

  private apiUrl: String = environment.apiUrl;
  private headers = new Headers({ 'Content-Type': 'application/json' });

  getAnalytics(type: String, past?, future?, entries?): Observable<any> {
    let chosenEntries = 'all';

    if (past && future) {
      chosenEntries = entries ? entries : 'all';
      return this.http
        .get(`${this.apiUrl}/analytics?type=` + type + '&past=' + past +
        '&future=' + future + '&entries=' + chosenEntries, { headers: this.headers })
        .map(response => {
            return response.json();
        });
    }else {
      return this.http
        .get(`${this.apiUrl}/analytics?type=` + type, { headers: this.headers })
        .map(response => {
            return response.json();
        });
    }
  }


  getGoalAnalytics(type: String, item): Observable<any> {

      return this.http
        .get(`${this.apiUrl}/analytics?type=` + type + '&goal_id=' + item.id, { headers: this.headers })
        .map(response => {
            return response.json();
        });
  }
}







// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-services/analytics.service.ts